/*
 * SashiDo
 * All rights reserved.
 */

import SashiDo from 'lib/SashiDo';

import AppsManager from 'lib/AppsManager';
import React                    from 'react';
import Button                   from 'components/Button/Button.react';
import Toolbar                  from 'components/Toolbar/Toolbar.react';
import styles                   from './Referrals.scss';
import settingsStyles           from 'dashboard/Settings/Settings.scss';
import stylesBilling            from 'dashboard/Billing/Billing.scss';
import PreLoader                from 'components/PreLoader/PreLoader.react';
import Field                    from 'components/Field/Field.react';
import TextInput                from 'components/TextInput/TextInput.react';
import Label                    from 'components/Label/Label.react';
import CopyToClipboard          from 'react-copy-to-clipboard';
import Icon                     from 'components/Icon/Icon.react';
import KeyField                 from 'components/KeyField/KeyField.react';
import SashiDoTable             from 'components/SashiDo/SashiDoTable.react';
import BoxFieldset              from 'components/BoxFieldset/BoxFieldset.react';

import Tooltip from 'rc-tooltip';

import * as formatter from 'lib/formatter';

export default class Referrals extends React.Component {
  constructor(props) {
    super();

    this.section = '';
    this.subsection = 'Referrals';

    this.state = {
      loading: false,
      copied: false,
      sendTo: '',
      messageBody: '',

      referralCode: '',
      referrals: [],
    }

    this.getReferralCode();
    this.getReferrals();
  }

  getReferralCode() {
    return SashiDo.getUserReferralCode().then(({referral_code}) => {
      this.setState({
        referralCode: 'https://www.sashido.io/?ref=' + referral_code,
        messageBody:
`Hi ,
I love my experience on SashiDo and want to share it with you.

SashiDo is a real Parse alternative.

Use my link https://www.sashido.io/?ref=${referral_code} and you'll have 30 days free!

I'm eager to hear what you think :)
`
      });
    });
  }

  getReferrals() {
    return SashiDo.getUserReferrals().then(({users}) => {
      this.setState({referrals: users})
    });
  }

  handleCopy() {
    setTimeout(() => this.setState({ copied: false }), 800);

    this.setState({
      copied: true
    });
  }

  handleSendTo(newValue) {
    this.setState({
      sendTo: newValue
    })
  }

  render() {
    let classes = [settingsStyles.settings_page, settingsStyles.default];

    let inviteByEmail = (
      <BoxFieldset el="referrals__refer_by_email">
        <div className={settingsStyles.settingsBox}>
          <Field
            label={<Label text='Send To' />}
            input={
              <TextInput
                value={this.state.sendTo}
                onChange={this.handleSendTo.bind(this)} />
            } />

          <Field
            label={<Label text="Message" />}
            input={

              <div className={styles.message}>
                <TextInput
                  value={this.state.messageBody}
                  multiline={true}
                  height={220}
                  onChange={(messageBody) => {this.setState({messageBody})}}
                />

                <CopyToClipboard text={this.state.messageBody} onCopy={this.handleCopy.bind(this)}>
                  <Tooltip placement="right" overlay={'Copy to Clipboard'} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                    <span className={[styles.copyIcon, this.state.copied ? styles.active : null].join(' ')}>
                      {this.state.copied
                        ? <Icon name={'icon-check'} width={16} height={16} />
                        : <Icon name={'icon-copy'} width={16} height={16} />
                      }
                    </span>
                  </Tooltip>
                </CopyToClipboard>

                <Button
                  href={'mailto:' + this.state.sendTo + '?&body=' + encodeURIComponent(this.state.messageBody)}
                  color='green'
                  value='Send the personal invite'
                  block={true}
                  disabled={this.state.sendTo === ''}
                  onClick={() => {}} />
              </div>
            } />
        </div>
      </BoxFieldset>
    );

    let shareButtons = (
      <BoxFieldset el='referrals__share_your_link'>
        <div className={settingsStyles.settingsBox}>
          <Field
            label={<Label text='Your personal referral link' />}
            input={<KeyField>{this.state.referralCode}</KeyField>} />

          <div className={settingsStyles.hr} />

          <Field
            label={<Label text='Share it with your friends and followers.' />}
            input={

              <div className={styles.icons}>
                <a
                  title="Share on Facebook"
                  href={'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.state.referralCode)}
                  onClick={(e) => {window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.state.referralCode), 'share','width=580,height=296');e.preventDefault();}}
                  className={styles.facebook}>
                  <Icon name={'icon-facebook'} width={30} height={30} colored={true} />
                </a>
                <a
                  title="Share on Twitter"
                  href={'https://twitter.com/intent/tweet?text=' + encodeURIComponent("@SashiDoIO is the Real #Parse alternative! Enjoy and happy coding " + this.state.referralCode + " #iOS #android #mobiledev #parseshutdown") + '&url=' + encodeURIComponent(this.state.referralCode)}
                  onClick={(e) => {window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent("@SashiDoIO is the Real #Parse alternative! Enjoy and happy coding " + this.state.referralCode + " #iOS #android #mobiledev #parseshutdown"), 'share','width=580,height=296');e.preventDefault();}}
                  className={styles.twitter}>
                  <Icon name={'icon-twitter'} width={30} height={30} colored={true} />
                </a>
                <a
                  title="Share on Ycombinator"
                  href={'https://news.ycombinator.com/submitlink?u=' + encodeURIComponent(this.state.referralCode) + '&t=' + encodeURIComponent("@SashiDo is the Real #Parse alternative! Enjoy and happy  coding" + this.state.referralCode + " #iOS #android #mobiledev #parseshutdown")}
                  onClick={(e) => {window.open('https://news.ycombinator.com/submitlink?u=' + encodeURIComponent(this.state.referralCode) + '&t=' + encodeURIComponent("@SashiDo is the Real #Parse alternative! Enjoy and happy  coding" + this.state.referralCode + " #iOS #android #mobiledev #parseshutdown"), 'share','width=580,height=296');e.preventDefault();}}
                  className={styles.ycombinator}>
                  <Icon name={'icon-ycombinator'} width={30} height={30} colored={true} />
                </a>
                <a
                  title="Share on Reddit"
                  href={'https://www.reddit.com/submit?url=' + encodeURIComponent(this.state.referralCode) + '&title=' + encodeURIComponent("@SashiDo is the Real #Parse alternative! Enjoy and happy  coding" + this.state.referralCode + " #iOS #android #mobiledev #parseshutdown")}
                  onClick={(e) => {window.open('https://www.reddit.com/submit?url=' + encodeURIComponent(this.state.referralCode) + '&title=' + encodeURIComponent("@SashiDo is the Real #Parse alternative! Enjoy and happy  coding" + this.state.referralCode + " #iOS #android #mobiledev #parseshutdown"), 'share','width=840,height=496');e.preventDefault();}}
                  className={styles.reddit}>
                  <Icon name={'icon-reddit'} width={34} height={34} colored={true} />
                </a>
                <a
                  title="Share on Google+"
                  href={'https://plus.google.com/share?url=' + this.state.referralCode}
                  onClick={(e) => {window.open('https://plus.google.com/share?url=' + this.state.referralCode, 'share','width=840,height=496');e.preventDefault();}}
                  className={styles.gplus}>
                  <Icon name={'icon-gplus'} width={26} height={26} colored={true} />
                </a>
                <a
                  title="Share on LinkedIn"
                  href={'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(this.state.referralCode) + '&title=' + encodeURIComponent("@SashiDo is the Real #Parse alternative! Enjoy and happy coding " + this.state.referralCode + " #iOS #android #mobiledev #parseshutdown") + '!&source=sashido.io'}
                  onClick={(e) => {window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(this.state.referralCode) + '&title=' + encodeURIComponent("@SashiDo is the Real #Parse alternative! Enjoy and happy coding " + this.state.referralCode + " #iOS #android #mobiledev #parseshutdown") + '!&source=sashido.io', 'share','width=840,height=496');e.preventDefault();}}
                  className={styles.linkedin}>
                  <Icon name={'icon-linkedin'} width={26} height={26} colored={true} />
                </a>
              </div>

            } />
        </div>
      </BoxFieldset>
    );

    let wallet = (
      <BoxFieldset el='referrals__virtual_wallet'>
        <div className={settingsStyles.settingsBox}>
          <div className={[stylesBilling.box, stylesBilling.table, stylesBilling.wallet].join(' ')}>
            <div className={[stylesBilling.tableRow, stylesBilling.last].join(' ')}>
              <div className={stylesBilling.col1}>
                <Icon name='icon-coins' width={30} height={30} />
              </div>
              <div>
                <div className={stylesBilling.totalPrice}>
                  <div className={stylesBilling.usagePrice}>
                    {formatter.price(this.props.currentCustomer.info.promotional_credits)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BoxFieldset>
    );

    let box = (
      <BoxFieldset el='referrals__give_30_days'>
        <div className={[settingsStyles.settingsBox, settingsStyles.info].join(' ')}>
          <div>
            <p>Everyone you refer gets 30 days free on SashiDo. You get immediately 50K requests for your apps and once they've spent $15 with us, you'll get $15</p>
          </div>
        </div>
      </BoxFieldset>
    );

    let userTable = (
      <BoxFieldset el='referrals__stats'>
        <div className={settingsStyles.settingsBox}>
          <div className={[stylesBilling.box].join(' ')}>
            <SashiDoTable className='in_box'>
              <colgroup>
                <col width="72%" />
                <col width="14%" />
                <col width="14%" />
              </colgroup>
              <thead>
                <tr>
                  <th>User Email</th>
                  <th className="align-center">Sign Up</th>
                  <th className="align-center">Spent $15</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.referrals.map((user, i) =>
                  {
                    let row = (
                      <tr key={`k-${i}`}>
                        <td>{formatter.obscureEmail(user.email)}</td>
                        <td className="align-center">
                          {
                            user.date_activated
                              ?
                                <Tooltip placement="right" overlay={'You received 50k requests for each of your apps.'} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                  <span>
                                    <Icon name={'icon-check'} width={16} height={16} fill="#00db7c"/>
                                  </span>
                                </Tooltip>
                              :
                                <Tooltip placement="right" overlay={'Not signed up.'} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                  <span>
                                    -
                                  </span>
                                </Tooltip>
                          }
                        </td>
                        <td className="align-center">
                          {
                            user.payment_status
                              ?
                                <Tooltip placement="right" overlay={"You have received $15"} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                  <Icon name={'icon-check'} width={16} height={16} fill="#00db7c"/>
                                </Tooltip>
                              :
                                <Tooltip placement="right" overlay={'Still not spent $15'} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                  <span>
                                    -
                                  </span>
                                </Tooltip>
                          }
                        </td>
                      </tr>
                    );

                    return row
                  })
                }
                {/*
                <tr>
                  <td>{formatter.obscureEmail('pafelka@gmail.com')}</td>
                  <td className="align-center">-</td>
                  <td className="align-center">-</td>
                </tr>
                <tr>
                  <td>{formatter.obscureEmail('admin@parseground.com')}</td>
                  <td className="align-center"><Icon name={'icon-check'} width={16} height={16} fill="#00db7c"/></td>
                  <td className="align-center">-</td>
                </tr>
                <tr>
                  <td>{formatter.obscureEmail('testimonials@sashido.io')}</td>
                  <td className="align-center"><Icon name={'icon-check'} width={16} height={16} fill="#00db7c"/></td>
                  <td className="align-center"><Icon name={'icon-check'} width={16} height={16} fill="#00db7c"/></td>
                </tr>
                */}
              </tbody>
            </SashiDoTable>
          </div>
        </div>
      </BoxFieldset>
    );

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection} />
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            {box}
            {wallet}
            {inviteByEmail}
            {shareButtons}
            {userTable}
          </div>
        </PreLoader>
      </div>
    );
  }
}

